import { ClientRepresentationStatusEnum } from '@sr-sdks/api-sdk-axios';
import { ReactNode } from 'react';
import { Button, ButtonGroup } from 'react-daisyui';
import { ButtonGroupProps } from 'react-daisyui/dist/ButtonGroup/ButtonGroup';
import './AppTabMenu.css';

export type IAppTabMenuGroupProps = ButtonGroupProps;

export const AppTabMenuGroup = ({
  children,
  className,
}: IAppTabMenuGroupProps) => {
  return (
    <ButtonGroup
      className={`btn-group-vertical flex sm:btn-group-horizontal ${className}`}
    >
      {children}
    </ButtonGroup>
  );
};

export interface IAppTabMenuItemProps {
  currentTab: ClientRepresentationStatusEnum;
  defaultTab?: boolean;
  itemCount?: number;
  label: ReactNode | string;
  setCurrentTab: (tabKey: ClientRepresentationStatusEnum) => void;
  tabKey: ClientRepresentationStatusEnum;
  tabToolTip?: string;
}

export const AppTabMenuItem = ({
  currentTab,
  defaultTab = false,
  itemCount,
  label,
  setCurrentTab,
  tabKey,
  tabToolTip,
}: IAppTabMenuItemProps) => {
  const isActiveTab = currentTab === tabKey || (!currentTab && defaultTab);

  const handleClick = () => {
    setCurrentTab(tabKey);
  };

  return (
    <>
      <Button
        id="tab-menu"
        className={`btn flex-1 border-none px-0 py-2.5 text-base normal-case hover:bg-secondary ${
          isActiveTab
            ? 'active btn-secondary font-medium text-primary'
            : 'font-normal text-sr-black hover:text-primary'
        }`}
        onClick={handleClick}
      >
        {label} {itemCount !== undefined ? `(${itemCount})` : ''}
      </Button>
      {tabToolTip && (
        <p
          className={`absolute z-50 rounded-lg border border-gray-300 bg-white p-4 text-xs text-gray-600 shadow-md xs:!top-1/3 sm:!top-[15%] ${tabKey}`}
        >
          {tabToolTip}
        </p>
      )}
    </>
  );
};

export const AppTabMenuModal = {
  Group: AppTabMenuGroup,
  Item: AppTabMenuItem,
};

export default AppTabMenuModal;
